import LayoutCentered from '@/layout/LayoutCentered';

export default [
  {
    path: '/vacations',
    component: LayoutCentered,
    meta: {
      auth: true,
      requirePermission: 'admin',
    },
    children: [
      {
        path: '',
        component: () => import('@/components/pages/vacations/VacationTabs.vue'),
        children: [
          {
            path: '',
            redirect: 'all-users'
          },
          {
            path: 'team-schedule',
            name: 'TeamSchedule',
            component: () => import('@/components/pages/vacations/TeamSchedule.vue'),
          },
          {
            path: 'pending-approvals',
            name: 'PendingApprovals',
            component: () => import('@/components/pages/vacations/PendingApprovals.vue'),
          },
          {
            path: 'all-users',
            name: 'AllUsers',
            component: () => import('@/components/pages/vacations/AllUsers.vue'),
          },
           {
            path: 'vacation-policy',
            name: 'VacationPolicy',
            component: () => import('@/components/pages/vacations/VacationsPolicy.vue'),
          },
        ],
      },
    ],
  },
];